import Base from './view/Base';
import Main from './view/Main';
import { defaultInitConfig } from './config';

/**
 * HabitsGames
 */
class HabitsGames {
    /**
     * 初期化
     *
     * @param {object} options コンフィグオプション
     */
    init(config) {
        Base.config = {
            ...defaultInitConfig,
            ...config,
        };

        this.main = new Main();
        this.main.observe();
    }
}

window.dhg = new HabitsGames();
